/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { homedir } from 'os';
import { IProcessEnvironment, platform } from '../../../base/common/platform.js';
import { URI } from '../../../base/common/uri.js';
import { INativeMcpDiscoveryData, INativeMcpDiscoveryHelperService } from '../common/nativeMcpDiscoveryHelper.js';

export class NativeMcpDiscoveryHelperService implements INativeMcpDiscoveryHelperService {
	declare readonly _serviceBrand: undefined;

	constructor(private readonly environment: IProcessEnvironment = process.env) { }

	load(): Promise<INativeMcpDiscoveryData> {
		return Promise.resolve({
			platform,
			homedir: URI.file(homedir()),
			copilotHome: this.uriFromEnvVariable('COPILOT_HOME'),
			winAppData: this.uriFromEnvVariable('APPDATA'),
			xdgHome: this.uriFromEnvVariable('XDG_CONFIG_HOME'),
		});
	}

	private uriFromEnvVariable(varName: string) {
		const envVar = this.environment[varName];
		if (!envVar) {
			return undefined;
		}
		return URI.file(envVar);
	}
}
